<template>
  <div>
    <AppLayout>
      <template #header>
        <div>
          <Navbar
            :brandIconName="brandIconName"
            :defaultEdgeIcon="defaultEdgeIcon"
            :isMobile="isMobile"
            :profileIconName="profileIconName"
            :projectIconName="projectIconName"
            @go-to-prev-tab="goToPrevTab"
            @go-to-next-tab="goToNextTab"
          />
        </div>
      </template>
      <template #mainContent>
        <EnrollFormCp ref="enrollFormCpRef" />
      </template>
      <template #footerContent>
        <Footer class="footer" />
      </template>
    </AppLayout>
  </div>
  <AutoLogout />
</template>

<script>
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import AppLayout from "../components/Layout/DefaultLayout.vue";
import Navbar from "../components/Layout/Navbar.vue";
import EnrollFormCp from "../components/EnrollForm/EnrollForm.vue";
import Footer from "../components/Layout/Footer.vue";
import AutoLogout from "../components/AutoLogout.vue";

export default {
  name: "App",
  components: {
    Footer,
    AppLayout,
    EnrollFormCp,
    AutoLogout,
  },
  setup() {
    const events = [
      "click",
      "mousemove",
      "mousedown",
      "scroll",
      "keypress",
      "load",
    ];
    const windowWidth = ref(0);
    const brandIconName = "logoUfma";
    const projectIconName = "mpb_logo";
    const profileIconName = "profileIcon_1";
    const isMobile = computed(() => windowWidth.value < 768);
    const defaultEdgeIcon = computed(() => (isMobile.value ? "2" : "3"));
    const footerSlot = ref("Rodapé Personalizado");
    const enrollFormCpRef = ref();

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    // const AppHandle = () => {
    //   this.$refs.enrollFormView.nextTab();
    // };

    const goToPrevTab = () => {
      nextTick(() => {
        enrollFormCpRef.value.prevTab();
      });
    };

    const goToNextTab = () => {
      nextTick(() => {
        enrollFormCpRef.value.nextTab();
      });
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      handleResize();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });

    const imgSrc = (iconName) => {
      return require("@/assets/layout/" + iconName + ".svg");
    };

    return {
      events,
      windowWidth,
      brandIconName,
      projectIconName,
      profileIconName,
      isMobile,
      defaultEdgeIcon,
      handleResize,
      imgSrc,
      footerSlot,
      enrollFormCpRef,
      goToPrevTab,
      goToNextTab,
    };
  },
  created() {
    if (this.$store.state.auth.status.loggedIn)
      console.log(this.$store.state.auth.status.loggedIn, "login");
  },
  beforeCreate() {
    this.$options.components.Navbar = Navbar;
  },
};
</script>
<!-- 
<style lang="scss">
/* * {
  font-family: "Open Sans", sans-serif;
} */

.container-fluid.container-content.desktop {
  /* height: 100vh; */
  padding-left: 5rem !important;
  padding-right: 5rem !important;
  padding-bottom: 5rem !important;
  padding-top: 10rem

 -->
<style lang="scss" scoped>
.footer {
  height: 7rem;
  justify-self: center;
}
</style>
